import { useQuery } from "@tanstack/react-query";
import { apiClient } from "./client";

export interface StructuredNotification {
  id: string;
  type: string;
  title: string;
  body: string;
  link?: string;
  read: boolean;
  createdAt: string;
}

// Dashboard notifications — polls the owner-only REST endpoint every 60s.
// The bell is empty for admins until admin-targeted events are added in a later prompt.
export const useStructuredNotifications = (userId: string | null | undefined, token: string | null | undefined) =>
  useQuery<{ notifications: StructuredNotification[] }>({
    queryKey: ["notificationsStructured", userId],
    queryFn: async () => {
      if (!userId || !token) return { notifications: [] };
      const res = await apiClient.get(`notifications-structured/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data || { notifications: [] };
    },
    enabled: !!userId && !!token,
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
